import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsStandUpPaddlingNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.23 18.767l-.418 2.751a1.876 1.876 0 001.854 2.157h.711a1.874 1.874 0 001.861-2.105L9.9 18.817A1.853 1.853 0 008.675 17.3V2.675h.716v-1.35h-2.8v1.35h.733v14.673a1.84 1.84 0 00-1.095 1.42zm1.333.2a.5.5 0 011 .013l.337 2.755a.525.525 0 01-.52.59h-.714a.528.528 0 01-.52-.605l.417-2.753zM13.366 12.014c0 1.441.215 2.874.639 4.251l.739 2.4h1.434l.737-2.4c.428-1.397.644-2.85.639-4.312A2.1 2.1 0 0015.045 9.9a2.13 2.13 0 00-1.679 2.114zm2.094-.8c.172 0 .34.06.473.17a.786.786 0 01.271.635c0 1.306-.195 2.606-.58 3.854l-.164.534-.164-.534a13.075 13.075 0 01-.58-3.854.786.786 0 01.588-.789.746.746 0 01.156-.02v.004z"
        fill=""
      />
      <path
        d="M12.812 1.881a14.209 14.209 0 00-1.844 6.995 40.852 40.852 0 001.5 10.988l.737 2.644a1.561 1.561 0 001.5 1.138h1.5a1.562 1.562 0 001.5-1.138l.738-2.644a40.921 40.921 0 001.5-10.988A14.22 14.22 0 0018.1 1.881a3.044 3.044 0 00-5.3 0h.013zm4.123.666A12.878 12.878 0 0118.6 8.876c.001 3.59-.487 7.165-1.452 10.624l-.738 2.644a.206.206 0 01-.2.151h-1.5a.206.206 0 01-.2-.15l-.738-2.645a39.514 39.514 0 01-1.455-10.624 12.876 12.876 0 011.668-6.329 1.7 1.7 0 012.95 0z"
        fill=""
      />
    </svg>
  )
);
SvgSportsStandUpPaddlingNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsStandUpPaddlingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsStandUpPaddlingNormalSmall;
